export const nowQuickCategories = [
  { name: 'Medicines', slug: 'medicines', image: 'https://cdn.magicpatterns.com/patterns/generated-images/225752e9-ff4d-42c2-9ed4-f596feca44f3.jpg' },
  { name: 'Vitamins', slug: 'vitamins-supplements', image: 'https://cdn.magicpatterns.com/patterns/generated-images/7c15dbf2-c7b9-4fd4-9612-28112ec7c2b8.jpg' },
  { name: 'Skin Care', slug: 'beauty-skin-care', image: 'https://cdn.magicpatterns.com/patterns/generated-images/7d01da99-d99e-47be-873c-dd4767e477dd.jpg' },
  { name: 'Mom & Baby', slug: 'baby-mother-care', image: 'https://cdn.magicpatterns.com/patterns/generated-images/e27c3344-f0eb-4d45-98e1-7548944ab240.jpg' },
  { name: 'Hair Care', slug: 'hair-care', image: 'https://cdn.magicpatterns.com/patterns/generated-images/f137b51f-f28a-44f6-a8e7-a6d739250f8b.jpg' },
  { name: 'First Aid', slug: 'first-aid', image: 'https://cdn.magicpatterns.com/patterns/generated-images/e069b32e-8558-4904-84e3-2e76f161a034.jpg' },
  { name: 'Devices', slug: 'medical-devices', image: 'https://cdn.magicpatterns.com/patterns/generated-images/dec05b1c-7059-4da6-9253-20631665dc1b.jpg' },
  { name: 'Personal Care', slug: 'personal-care', image: 'https://cdn.magicpatterns.com/patterns/generated-images/c7bd6f6e-ad46-4d48-b3c1-93277b798a5f.jpg' },
] as const

export const nowFeaturedCategories = [
  { name: 'Deal Zone', path: '/offers', image: 'https://cdn.magicpatterns.com/patterns/generated-images/ed4cf7f7-57a9-4409-a6d5-38284a0a43b3.jpg' },
  { name: 'Flu & Allergy', path: '/category/medicines', image: 'https://cdn.magicpatterns.com/patterns/generated-images/245d318c-34a2-41a5-8e22-f444c80e33d3.jpg' },
  { name: 'Healthy Products', path: '/category/health-wellness', image: 'https://cdn.magicpatterns.com/patterns/generated-images/2b68ca0d-d49c-4c31-9df5-2cd6ea289cee.jpg' },
  { name: 'Top Sellers', path: '/category/medicines', image: 'https://cdn.magicpatterns.com/patterns/generated-images/4d1e3434-d916-4810-857e-a6ab86bbd5a9.jpg' },
] as const

export const nowHeroSlides = [
  {
    title: 'Pharmacy essentials, delivered within 120 minutes.',
    description: 'Everyday care, selected for fast delivery near you.',
    action: 'Shop essentials',
    path: '/category/medicines',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/ddb0076b-cd8e-4206-ba68-96a424f9563a.jpg',
  },
  {
    title: 'Wellness essentials, ready when you are.',
    description: 'Shop everyday vitamins and supplements with NOW 120.',
    action: 'Shop wellness',
    path: '/category/vitamins-supplements',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/5bb19b31-7a31-40ac-8b9f-4a8ff2fe2f88.jpg',
  },
  {
    title: 'Care for your little ones, delivered fast.',
    description: 'Baby essentials selected for the moments that cannot wait.',
    action: 'Shop baby care',
    path: '/category/baby-mother-care',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/b1013419-656b-4863-8607-d9deb769aff2.jpg',
  },
] as const

export const nowPromotions = [
  {
    title: 'Everyday wellness, delivered faster',
    description: 'Selected vitamins and essentials ready for NOW 120 delivery.',
    action: 'Shop wellness',
    path: '/category/vitamins-supplements',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/5bb19b31-7a31-40ac-8b9f-4a8ff2fe2f88.jpg',
  },
  {
    title: 'Baby essentials, when you need them',
    description: 'Care for little ones, ready for fast delivery near you.',
    action: 'Shop baby care',
    path: '/category/baby-mother-care',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/b1013419-656b-4863-8607-d9deb769aff2.jpg',
  },
] as const

export const nowNeeds = [
  { name: 'Cold & Flu', description: 'Fast relief for seasonal symptoms', slug: 'medicines', image: 'https://cdn.magicpatterns.com/patterns/generated-images/f3d21967-60c1-463f-acc2-5a0c8d7a8c88.jpg' },
  { name: 'Pain Relief', description: 'Everyday care when you need it', slug: 'medicines', image: 'https://cdn.magicpatterns.com/patterns/generated-images/28135eb1-fc9d-4e41-bda2-8609e2eafc62.jpg' },
  { name: 'Digestive Care', description: 'Comfort and daily gut support', slug: 'health-wellness', image: 'https://cdn.magicpatterns.com/patterns/generated-images/d012cd71-286a-42cd-95e7-1650d727ff81.jpg' },
  { name: 'Allergy', description: 'Seasonal care, ready when you are', slug: 'medicines', image: 'https://cdn.magicpatterns.com/patterns/generated-images/56261cb0-0e8f-4042-95bd-fd5dff801794.jpg' },
  { name: 'First Aid', description: 'Essentials for home and travel', slug: 'first-aid', image: 'https://cdn.magicpatterns.com/patterns/generated-images/fbbe33f0-4839-4bf5-b591-a3ac5c312a3b.jpg' },
  { name: 'Sleep & Relax', description: 'Wind down and recharge', slug: 'vitamins-supplements', image: 'https://cdn.magicpatterns.com/patterns/generated-images/6bd7258a-aaaa-4e51-9ad6-a40a964c9160.jpg' },
] as const

export const nowBrands = [
  { name: 'Panadol', category: 'Pain relief', image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1000157_1.jpg' },
  { name: 'Centrum', category: 'Daily vitamins', image: 'https://img.innovapharmacy.com/media/catalog/product/4/5/4537b3e3-4206-41fc-b34e-53ddce591f66_1.jpg' },
  { name: 'QV', category: 'Skin essentials', image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1030868_1.png' },
  { name: 'Cetaphil', category: 'Gentle care', image: 'https://img.innovapharmacy.com/media/catalog/product/2/1/213099.jpg' },
  { name: 'Mustela', category: 'Baby care', image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1015683_1.jpg' },
  { name: 'Bioderma', category: 'Dermatology', image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1000157_1.jpg' },
] as const
